import React from 'react';

// Consistent page title block. `eyebrow` is a small uppercase kicker.
export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0">
        {eyebrow && <div className="text-[11px] uppercase tracking-wider text-brand-600 font-semibold">{eyebrow}</div>}
        <h1 className="mt-0.5 text-xl md:text-2xl font-semibold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
